module.exports = __webpack_public_path__ + "img/BowArrow.aa0f3078.gif";